import moment from 'moment/moment';

export const dateTimeFormat = (date: string) => {
    return moment(date).format('DD-MM-YYYY HH:mm');
}